/**
 * reducers/reports.ts
 * desc: client reports
 * note:
 */

import type { Reducer } from '@reduxjs/toolkit';
import type { ReportsAction } from '../actions/reports';

export interface ReportsState {
    isLoading: {
        getTrainingData: boolean;
    };
}

const INITIAL_STATE: ReportsState = {
    isLoading: {
        getTrainingData: false,
    }
};


function reportsReducer(state: ReportsState = INITIAL_STATE, action: ReportsAction): ReportsState {
    switch (action.type) {
        // GET Training Data Report
        case 'GET_REPORT_TRAINING_DATA_ERROR':
            return _getReporTrainingDataError(state);
        case 'GET_REPORT_TRAINING_DATA_REQUEST':
            return _getReporTrainingDataRequest(state);
        case 'GET_REPORT_TRAINING_DATA_SUCCESS':
            return _getReporTrainingDataSuccess(state);

        default:
            return state;
    }
}



//*************************************************
//*****   GET Training Data Report  ***************
//*************************************************
function _getReporTrainingDataError(state: ReportsState): ReportsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTrainingData: false,
        },
    };
}

function _getReporTrainingDataRequest(state: ReportsState): ReportsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTrainingData: true,
        },
    };
}

function _getReporTrainingDataSuccess(state: ReportsState): ReportsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTrainingData: false,
        }
    };
}

export default reportsReducer as Reducer<ReportsState>;
